import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useUserActions } from 'actions/user';
import XALogoLight from 'assets/images/xa-logo-b.webp';
import XALogoDark from 'assets/images/xa-logo-w.webp';
import {
  buildLoginHeroImageSet,
  getLoginHeroImageForPathname,
} from 'config/loginPortals';
import './style.scss';

function AuthLayout() {
  const location = useLocation();
  const [theme, setTheme] = useState('');
  const userActions = useUserActions();
  const heroImage = getLoginHeroImageForPathname(location.pathname);
  const authPageStyle = useMemo(
    () =>
      ({
        '--xa-auth-hero-image': buildLoginHeroImageSet(heroImage),
      }) as React.CSSProperties,
    [heroImage],
  );
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  useEffect(() => {
    setTheme(userActions.getUserTheme());
  }, [userActions]);

  useEffect(() => {
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = heroImage.webp;
    if (heroImage.webp.endsWith('.webp')) {
      preloadLink.type = 'image/webp';
    }
    document.head.appendChild(preloadLink);

    return () => {
      document.head.removeChild(preloadLink);
    };
  }, [heroImage.webp]);

  const changeTheme = () => {
    userActions.toggleUserTheme();
    setTheme(userActions.getUserTheme());
  };

  return (
    <div className="main-content">
      <section className="xa-auth-page" style={authPageStyle}>
        <div className="xa-auth-page-content">
          <div className="xa-auth-page-theme-toggle" onClick={changeTheme} />
          <div className="xa-auth-page-content-wrapper">
            <div className="xa-auth-page-login-box">
              <div className="xa-auth-page-title">
                <h1>
                  XA<sup>&copy;</sup> Explorer
                </h1>
              </div>
              <Outlet />
              <div className="xa-auth-page-logo">
                <img
                  src={theme === 'dark' ? XALogoDark : XALogoLight}
                  alt="XA Logo"
                />
              </div>
            </div>
          </div>
          <div className="xa-auth-page-copyright">
            &copy; {getCurrentYear()}
            {' XAIS Asset Management Ltd. All Rights Reserved.'}
          </div>
          <div className="xa-auth-page-separator">
            <div className="xa-auth-page-polygon"></div>
          </div>
        </div>
        <div className="xa-auth-page-image" aria-hidden="true" />
      </section>
    </div>
  );
}

export default AuthLayout;
